$(function ($) {

    window.Urls = $.extend(window.Urls, {}, {
        VerifyMobileAndEmail: "/Account/VerifyMobileAndEmail",
    });(jQuery);

    $(document).ready(function () {

        var element = $("[data-widget=VerifyInformationButtonFolkspel]");

        $('#verifyButton', element).on('click', function () {
            window.Utils.VerifyMobileAndEmail();
            console.log('Knapp klickad');
        })


        const urlParams = new URLSearchParams(window.location.search);
        const value = urlParams.get('result');

        //TODO: Lägg till check för att se att användaren är authorized.
        if (value != null && value == 'success') {
            $('.VerifyDetailsContent').hide();
            $('.VerifiedDetailsContent').show();
        }

    })



})